import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCompanyContactsCount = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  return await axios.get(
    `/api/companies/${companyID}/contacts/count?${queryString}`
  );
};

const defaultQueryParams = {
  includeInactive: false,
  queryOptions: {},
};

export const useCompanyContactsCount = (companyID, queryParams = {}) => {
  const { includeInactive, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    includeinactive: includeInactive
  };

  return useQuery(
    `company-${companyID}-contacts-count-status-${includeInactive}`,
    () => getCompanyContactsCount(companyID, queryStringParams),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...queryOptions,
    }
  );
}